@if(!mobileStylesOnly){
<div class="table-wrapper d-none d-xl-block">
  <p-table [value]="orderLines" dataKey="id" [class.first]="first" class="right-aligned-table thead-lg trow-lg">
    <ng-template pTemplate="header">
      <tr>
        <th>
          <app-delivery-items-table-shipping-name></app-delivery-items-table-shipping-name>
        </th>
        <th>
          <div class="standard-item-table-label">Shipping</div>
        </th>
        @if (inOrder) {
        <th>
          <div class="standard-item-table-label">Status</div>
        </th>
        }
        <th>
          <div class="standard-item-table-label">QTY</div>
        </th>
        <th>
          <div class="standard-item-table-label">SUM</div>
        </th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-orderLine>
      <tr>
        <td class="name-table-column">
          <div class="table-item-name-wrapper">
            <app-product-image-wrapper [slug]="orderLine.productVariant.product?.slug">
              <div class="img-wrapper">
                @if(orderLine.featuredAsset){
                <img [src]="orderLine.featuredAsset | assetPreview:'thumb'" [alt]="orderLine.productVariant.name" />
                } @else {
                <img src="./.../../../../../../assets/images/placeholders/no-img-placeholder.svg"
                  [alt]="orderLine.productVariant.name">
                }
              </div>


            </app-product-image-wrapper>


            <app-product-details-header [name]="orderLine.productVariant?.name"
              [slug]="orderLine.productVariant?.product?.slug" [sku]="orderLine.productVariant?.sku"
              [manufacturer]="orderLine.productVariant?.product?.customAttributes?.manufacturer" [small]="true"
              [stockLevel]="orderLine.productVariant?.stockLevel"></app-product-details-header>

          </div>
        </td>
        <td class="shipping-table-column">
          @if (inCart) {
          <app-shipping-selector [shippingMethods]="[]" [smallLabel]="false" [darkMode]="false" [appendTo]="'body'">
          </app-shipping-selector>
          } @else if(inOrder || inOrderConfirmation) {

          <p class="default-delivery-item-text">{{order?.shippingLines?.[0].shippingMethod?.name}}<br />

            @if(order?.shippingLines?.[0].priceWithTax > 0){
            @if(order?.shippingLines?.[0].priceWithTax | formatPrice | async; as deliveryPrice){
            {{deliveryPrice}}
            }

            } @else {
            Free
            }
          </p>
          }
        </td>
        @if (inOrder) {
        <td class="status-table-column">
          <app-order-status-block [order]="order" [showStatusDate]="false"></app-order-status-block>
        </td>
        }
        <td class="quantity-table-column">
          @if (inCart) {
          <app-quantity-selector [loading]="loading$ | async" [maxWidth]="56"
            (quantityChangeForCart)="setQuantity($event)" [orderLine]="orderLine" [quantity]="orderLine.quantity"
            [smallButtons]="true" [darkMode]="false">
          </app-quantity-selector>
          } @else if(inOrder || inOrderConfirmation) {
          <p class="default-delivery-item-text">{{orderLine?.quantity}}</p>
          }

        </td>
        <td class="total-price-table-column">
          <app-delivery-items-table-price-block [orderLine]="orderLine"></app-delivery-items-table-price-block>
        </td>

        <td class="actions-table-column">
          @if (inCart) {
          <app-delete-cart-item-btn-block [orderLine]="orderLine"></app-delete-cart-item-btn-block>
          } @else if(inOrder) {
          <!--
              <p-menu [styleClass]="'standart-p-menu'" #orderActionsMenu [model]="orderActions" [popup]="true" [appendTo]="'body'" ></p-menu>
              <button (click)="orderActionsMenu.toggle($event)" pButton pRipple class="c-button icon-only table-action-btn p-unset-xxl">
                <img src="./../../../../assets/images/icons/more_horiz.svg" alt="delete">
              </button>
              -->


          }

        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

}

<div class="mobile-delivery-items-wrapper" [class.d-xl-none]="!mobileStylesOnly" [class.d-block]="!mobileStylesOnly">
  <app-delivery-items-card-list [orderLines]="orderLines" [first]="first" [inOrder]="inOrder" [inCart]="inCart"
    [order]="order"></app-delivery-items-card-list>
</div>
